import { PageSectionProps } from "@components/page-section/page-section";
import { Text } from "@flat-ui";
import { IntegrationList } from "@pages/account-settings/integrations-account/integration-list";

/** Content for the integrations tab of account settings page */
export function integrationsAccountTab(): PageSectionProps[] {
  return [
    {
      title: "Integration accounts",
      subtitle: "",
      shouldHideLeftColumn: true,
      sectionDescription: (
        <Text variant="bodyL">
          Link your Sphere XG account with other apps and services to streamline
          your workflow. Connections are personal and only available to you.
        </Text>
      ),
      items: [
        {
          content: <IntegrationList />,
          shouldHidePaddingY: true,
          shouldContentTakeFullWidth: true,
        },
      ],
    },
  ];
}
